<template>
  <div class="free-room-page pk-account-panel">
    <section v-if="roomUnavailable" class="room-unavailable">
      <strong>该福利 Roll 房间暂不可用</strong>
      <span>房间可能已结束、被删除或暂时无法读取。</span>
      <button type="button" @click="$router.push({ path: '/Arena' })">返回福利 Roll</button>
    </section>
    <section v-if="!roomUnavailable" class="room-hero">
      <button class="back-btn" @click="$router.push({ path: '/Arena' })">返回</button>
      <div class="room-avatar">
        <img :src="roomData.img || defaultRoomImg" alt="" @error="setImageFallback($event, defaultRoomImg)" />
        <span>{{ roomData.type == 1 ? "官方" : "主播" }}</span>
      </div>
      <div class="room-copy">
        <span>福利箱子房间</span>
        <h1>{{ roomData.room_name }}</h1>
        <p>{{ roomData.desc || "免费 Roll 房详情，奖池、参与者和奖品列表以房间页面展示为准。" }}</p>
      </div>
      <div class="room-action">
        <button v-if="roomData.status == 1" @click="addRoom">加入房间</button>
        <button v-else class="muted">已结束</button>
        <em>房间编号 {{ roomData.room_num || id }}</em>
      </div>
    </section>

    <section v-if="!roomUnavailable" class="room-stats-board">
      <article>
        <span>奖池</span>
        <strong>{{ moneyText(roomData.pool || price) }} <i></i></strong>
      </article>
      <article>
        <span>截止时间</span>
        <strong>{{ roomData.run_lottery_time || "-" }}</strong>
      </article>
      <article v-if="roomData.type != 1">
        <span>参与人数</span>
        <strong>{{ player_list.length }}</strong>
      </article>
      <article>
        <span>奖品数量</span>
        <strong>{{ list.length }}</strong>
      </article>
    </section>

    <section v-if="!roomUnavailable && roomData.status == 2" class="content-section">
      <div class="section-head">
        <div>
          <span>中奖玩家</span>
          <h2>中奖记录</h2>
        </div>
        <strong>{{ moneyText(player_skin_price) }} <i></i></strong>
      </div>
      <div class="winner-grid">
        <article v-for="item in player_skin" :key="item.player_name + item.name" class="winner-card">
          <div class="winner-skin">
            <img :src="item.skin_img || defaultPrizeImg" alt="" @error="setImageFallback($event, defaultPrizeImg)" />
            <span>{{ moneyText(item.price) }}</span>
          </div>
          <div class="winner-user">
            <img :src="item.player_img || defaultAvatar" alt="" @error="setImageFallback($event, defaultAvatar)" />
            <strong>{{ item.player_name }}</strong>
          </div>
          <p>{{ item.name }}</p>
        </article>
      </div>
    </section>

    <section v-if="!roomUnavailable" class="content-section">
      <div class="section-head">
        <div>
          <span>奖池</span>
          <h2>奖池奖品</h2>
        </div>
        <strong>{{ moneyText(price) }} <i></i></strong>
      </div>
      <div class="prize-grid">
        <article v-for="item in list" :key="item.id || item.name" class="prize-card">
          <img :src="item.img || defaultPrizeImg" alt="" @error="setImageFallback($event, defaultPrizeImg)" />
          <strong>{{ item.name }}</strong>
          <span>{{ moneyText(item.price) }} <i></i></span>
        </article>
      </div>
      <div v-if="!list.length" class="empty-card">暂无奖品数据。</div>
    </section>

    <section v-if="!roomUnavailable && roomData.type != 1" class="content-section">
      <div class="section-head">
        <div>
          <span>玩家</span>
          <h2>参与玩家</h2>
        </div>
        <strong>{{ player_list.length }} 人</strong>
      </div>
      <div class="players-grid">
        <article v-for="item in player_list" :key="item.id" class="player-card">
          <img :src="item.img || defaultAvatar" alt="" @error="setImageFallback($event, defaultAvatar)" />
          <span>{{ item.name || "玩家" }}</span>
        </article>
      </div>
      <div v-if="!player_list.length" class="empty-card">暂无玩家参与。</div>
    </section>

    <div class="pass-layer" v-if="!roomUnavailable && passState">
      <div class="pass-box">
        <button class="close-btn" @click="hidePass">×</button>
        <strong>输入房间口令</strong>
        <input type="text" v-model="password" />
        <button @click="passAddRoom">确认加入</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      password: "",
      passState: false,
      id: "",
      roomData: {},
      list: [],
      player_list: [],
      price: 0,
      player_skin: [],
      player_skin_price: 0,
      roomUnavailable: false,
      defaultRoomImg: require("../assets/hotpizza/hp-case-orange.png"),
      defaultPrizeImg: require("../assets/hotpizza/hp-ak-green.png"),
      defaultAvatar: require("../assets/img/jiapeople.png"),
    };
  },
  mounted() {
    this.id = this.$route.query.id;
    this.getRoomList();
  },
  computed: {
    loggedIn() {
      return Boolean(this.$store.state.token || localStorage.getItem("token"));
    },
  },
  methods: {
    addRoom() {
      if (!this.loggedIn) {
        this.openLogin();
        return;
      }
      if (this.roomData.condition_type == 1 || this.roomData.condition_type == 3) {
        this.passState = true;
        return;
      }
      this.joinRoom({ free_room_id: this.id });
    },
    hidePass() {
      this.passState = false;
    },
    passAddRoom() {
      this.joinRoom({ free_room_id: this.id, password: this.password });
    },
    joinRoom(param) {
      if (!this.loggedIn) {
        this.openLogin();
        return;
      }
      this.$axios.post("index/Free/addFreeRoom", this.$qs.stringify(param)).then((res) => {
        if (res.data.status == "1") {
          this.roomUnavailable = false;
          this.$message({ message: res.data.msg, type: "success" });
          this.getRoomList();
          this.passState = false;
        } else {
          this.$message({ message: res.data.msg, type: "error" });
        }
      });
    },
    getRoomList() {
      this.$axios.post("index/Free/freeRoomDetail", this.$qs.stringify({ free_room_id: this.id })).then((res) => {
        if (res.data.status == "1") {
          this.player_skin_price = 0;
          this.roomData = this.normalizeRoom(res.data.data);
          this.player_list = this.roomData.type == 1 ? [] : this.normalizePlayers(res.data.data.player_list || []);
          this.list = this.normalizePrizes(res.data.data.skin_list || []);
          this.price = res.data.data.pool;
          if (res.data.data.status == 2) {
            this.player_skin = this.normalizeWinners(res.data.data.player_skin || []);
            for (let i = 0; i < this.player_skin.length; i++) {
              this.player_skin_price += Number(this.player_skin[i].price);
            }
            this.player_skin_price = this.player_skin_price.toFixed(2);
          }
        } else {
          this.markRoomUnavailable();
        }
      }).catch(() => {
        this.markRoomUnavailable();
      });
    },
    moneyText(value) {
      return Number(value || 0).toFixed(2);
    },
    stableImage(value, fallback) {
      const image = String(value || "");
      if (!image) return fallback;
      if (image.indexOf("http://") === 0) return fallback;
      if (image.indexOf("https://img.zbt.com") === 0) return fallback;
      if (image.indexOf("csgoapi.akaifa998.icu") !== -1) return fallback;
      if (image.indexOf("standoffi.oss-cn-hongkong.aliyuncs.com") !== -1) return fallback;
      return image;
    },
    normalizeRoom(room) {
      room.img = this.stableImage(room.img, this.defaultRoomImg);
      return room;
    },
    normalizePrizes(list) {
      return list.map((item) => {
        item.img = this.stableImage(item.img || item.imageUrl, this.defaultPrizeImg);
        return item;
      });
    },
    normalizePlayers(list) {
      return list.map((item) => {
        item.img = this.stableImage(item.img, this.defaultAvatar);
        return item;
      });
    },
    normalizeWinners(list) {
      return list.map((item) => {
        item.skin_img = this.stableImage(item.skin_img || item.img, this.defaultPrizeImg);
        item.player_img = this.stableImage(item.player_img, this.defaultAvatar);
        return item;
      });
    },
    markRoomUnavailable() {
      this.roomUnavailable = true;
      this.passState = false;
      this.roomData = {};
      this.list = [];
      this.player_list = [];
      this.player_skin = [];
      this.price = 0;
      this.player_skin_price = 0;
    },
    setImageFallback(event, fallback) {
      if (event.target.src != fallback) {
        event.target.src = fallback;
      }
    },
    openLogin() {
      this.$store.commit("getLogin", true);
    },
  },
};
</script>

<style lang="less" scoped>
.free-room-page {
  min-height: calc(100vh - 198px);
  padding: 34px 34px 90px;
  color: #f5f7ff;
  background:
    radial-gradient(circle at 48% 0, rgba(255, 138, 31, 0.16), transparent 30%),
    radial-gradient(circle at 82% 24%, rgba(0, 217, 255, 0.1), transparent 28%),
    linear-gradient(180deg, #1f212d 0%, #171923 100%);
}

.room-unavailable {
  min-height: 420px;
  display: grid;
  justify-items: center;
  align-content: center;
  gap: 12px;
  color: #a6afc0;
  text-align: center;
}

.room-unavailable strong {
  color: #f4f6ff;
  font-size: 22px;
}

.room-unavailable button {
  min-width: 142px;
  height: 42px;
  margin-top: 8px;
  color: #fff3dd;
  background: linear-gradient(180deg, #ff9b28, #e25e00);
  border: 1px solid rgba(255, 198, 104, 0.64);
  border-radius: 7px;
  cursor: pointer;
  font: inherit;
  font-weight: 900;
}

button {
  font-family: inherit;
  cursor: pointer;
}

.room-hero,
.room-stats-board,
.content-section {
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
}

.room-hero {
  min-height: 280px;
  padding: 42px 50px;
  display: grid;
  grid-template-columns: 178px 1fr 220px;
  gap: 24px;
  align-items: center;
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  background:
    linear-gradient(130deg, rgba(41, 43, 58, 0.96), rgba(24, 26, 36, 0.98)),
    url("../assets/new/task_bg.png") center / cover;
  border: 1px solid rgba(255, 132, 31, 0.28);
  box-shadow: 0 26px 80px rgba(0, 0, 0, 0.34);
}

.room-hero::after {
  content: "";
  width: 780px;
  height: 280px;
  position: absolute;
  right: -160px;
  bottom: -160px;
  border-radius: 50%;
  background: radial-gradient(ellipse, rgba(255, 138, 0, 0.38), transparent 66%);
}

.back-btn {
  height: 44px;
  padding: 0 20px;
  position: absolute;
  right: 22px;
  top: 22px;
  z-index: 2;
  color: #f4f6ff;
  background: #303342;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 7px;
  font-weight: 1000;
}

.room-avatar,
.room-copy,
.room-action {
  position: relative;
  z-index: 1;
}

.room-avatar {
  text-align: center;
}

.room-avatar img {
  width: 138px;
  height: 138px;
  object-fit: cover;
  border-radius: 50%;
  border: 2px solid rgba(255, 138, 0, 0.56);
  box-shadow: 0 0 46px rgba(255, 138, 0, 0.22);
}

.room-avatar span {
  margin-top: -12px;
  padding: 5px 12px;
  display: inline-block;
  color: #151620;
  background: #ffb11f;
  border-radius: 99px;
  font-size: 12px;
  font-weight: 1000;
}

.room-copy span,
.section-head span,
.room-stats-board span {
  color: #ff8a1f;
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0.18em;
}

.room-copy h1 {
  margin: 12px 0 14px;
  color: #f8fbff;
  font-size: 50px;
  line-height: 1;
  font-weight: 1000;
}

.room-copy p {
  color: #aeb6c8;
  font-size: 16px;
  line-height: 1.8;
  font-weight: 800;
}

.room-action {
  display: grid;
  gap: 10px;
}

.room-action button,
.pass-box button {
  height: 44px;
  padding: 0 22px;
  color: #151620;
  background: linear-gradient(180deg, #ffd53b, #ff8300);
  border: 0;
  border-radius: 7px;
  font-weight: 1000;
}

.room-action .muted {
  color: #f4f6ff;
  background: #303342;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.room-action em {
  color: #9fa8bb;
  font-size: 13px;
  font-style: normal;
  font-weight: 900;
}

.room-stats-board {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}

.room-stats-board article {
  min-height: 106px;
  padding: 18px;
  border-radius: 12px;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.room-stats-board strong {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 7px;
  color: #f8fbff;
  font-size: 22px;
  font-weight: 1000;
}

.room-stats-board i,
.section-head i,
.prize-card i {
  width: 18px;
  height: 18px;
  display: inline-block;
  background: url("../assets/pizzaking/pizza-token.svg") center / contain no-repeat;
}

.content-section {
  margin-top: 20px;
  padding: 24px;
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(43, 45, 59, 0.95), rgba(31, 33, 45, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: 0 18px 54px rgba(0, 0, 0, 0.22);
}

.section-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.section-head h2 {
  margin: 8px 0 0;
  color: #f8fbff;
  font-size: 28px;
  font-weight: 1000;
}

.section-head strong {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #ffd764;
  font-size: 24px;
  font-weight: 1000;
}

.winner-grid,
.prize-grid,
.players-grid {
  margin-top: 18px;
  display: grid;
  gap: 12px;
}

.winner-grid {
  grid-template-columns: repeat(auto-fill, minmax(184px, 1fr));
}

.prize-grid {
  grid-template-columns: repeat(auto-fill, minmax(166px, 1fr));
}

.players-grid {
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
}

.winner-card,
.prize-card,
.player-card {
  border-radius: 10px;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.055);
}

.winner-card,
.prize-card {
  padding: 12px;
}

.winner-skin,
.prize-card {
  position: relative;
  min-height: 126px;
  display: grid;
  place-items: center;
  background: radial-gradient(circle at 50% 40%, rgba(129, 73, 255, 0.28), transparent 62%), #202330;
}

.winner-skin img,
.prize-card img {
  max-width: 134px;
  max-height: 90px;
  object-fit: contain;
  filter: drop-shadow(0 14px 18px rgba(0, 0, 0, 0.44));
}

.winner-skin span {
  position: absolute;
  left: 9px;
  bottom: 8px;
  color: #ffd764;
  font-size: 12px;
  font-weight: 1000;
}

.winner-user {
  margin-top: -16px;
  position: relative;
  display: grid;
  justify-items: center;
  gap: 6px;
}

.winner-user img,
.player-card img {
  width: 48px;
  height: 48px;
  object-fit: cover;
  border-radius: 50%;
  border: 1px solid rgba(255, 138, 0, 0.48);
}

.winner-user strong,
.player-card span {
  color: #f4f6ff;
  font-size: 13px;
  font-weight: 1000;
}

.winner-card p {
  margin: 10px 0 0;
  overflow: hidden;
  color: #9fa8bb;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 800;
}

.prize-card {
  align-content: center;
  min-height: 202px;
}

.prize-card strong {
  width: 100%;
  min-height: 34px;
  overflow: hidden;
  color: #f5f7ff;
  text-align: center;
  text-overflow: ellipsis;
  font-size: 13px;
  line-height: 1.35;
  font-weight: 1000;
}

.prize-card span {
  margin-top: 7px;
  display: flex;
  align-items: center;
  gap: 5px;
  color: #ffd764;
  font-weight: 1000;
}

.player-card {
  min-height: 100px;
  display: grid;
  place-items: center;
  gap: 8px;
}

.empty-card {
  margin-top: 18px;
  padding: 28px 18px;
  color: #929bad;
  text-align: center;
  background: #242735;
  border: 1px solid rgba(255, 255, 255, 0.055);
  border-radius: 10px;
  font-size: 14px;
  font-weight: 800;
}

.pass-layer {
  position: fixed;
  inset: 0;
  z-index: 999;
  display: grid;
  place-items: center;
  background: rgba(0, 0, 0, 0.64);
}

.pass-box {
  width: min(360px, calc(100% - 32px));
  padding: 26px;
  position: relative;
  display: grid;
  gap: 14px;
  color: #f4f6ff;
  background: #252836;
  border: 1px solid rgba(255, 138, 0, 0.28);
  border-radius: 14px;
  box-shadow: 0 22px 70px rgba(0, 0, 0, 0.45);
}

.pass-box strong {
  font-size: 22px;
  font-weight: 1000;
}

.pass-box input {
  height: 42px;
  padding: 0 12px;
  color: #f4f6ff;
  background: #1b1d28;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 7px;
  outline: none;
}

.pass-box .close-btn {
  width: 30px;
  height: 30px;
  padding: 0;
  position: absolute;
  right: 10px;
  top: 10px;
  color: #f4f6ff;
  background: #303342;
}

@media screen and (max-width: 980px) {
  .free-room-page {
    padding: 20px 12px 64px;
  }

  .room-hero,
  .room-stats-board {
    grid-template-columns: 1fr;
  }

  .room-hero {
    padding: 72px 24px 34px;
  }

  .room-copy h1 {
    font-size: 40px;
  }
}
</style>

<style lang="less">
.free-room-page.pk-account-panel {
  min-height: calc(100vh - 199px) !important;
  padding: 24px 24px 96px !important;
  background:
    radial-gradient(circle at 50% 0, rgba(255, 132, 31, 0.1), transparent 360px),
    #191b26 !important;
}

.free-room-page.pk-account-panel .room-hero,
.free-room-page.pk-account-panel .room-stats-board,
.free-room-page.pk-account-panel .content-section {
  width: 100% !important;
  max-width: none !important;
}

.free-room-page.pk-account-panel .room-hero {
  min-height: 292px !important;
  border: 1px solid rgba(236, 216, 184, 0.12) !important;
  border-radius: 8px !important;
  background:
    radial-gradient(circle at 18% 50%, rgba(255, 132, 31, 0.16), transparent 280px),
    linear-gradient(180deg, rgba(34, 36, 48, 0.96), rgba(30, 32, 43, 0.96)) !important;
  box-shadow: none !important;
}

.free-room-page.pk-account-panel .content-section,
.free-room-page.pk-account-panel .room-stats-board article,
.free-room-page.pk-account-panel .prize-card,
.free-room-page.pk-account-panel .winner-card,
.free-room-page.pk-account-panel .player-card {
  border-color: #2b2d3c !important;
  border-radius: 8px !important;
  background: #20222f !important;
  box-shadow: none !important;
}

.free-room-page.pk-account-panel .prize-grid,
.free-room-page.pk-account-panel .winner-grid {
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr)) !important;
  gap: 8px !important;
}

.free-room-page.pk-account-panel .prize-card {
  min-height: 238px !important;
}
</style>

<style lang="less">
.free-room-page.pk-account-panel {
  padding: 32px 28px 96px !important;
}

.free-room-page.pk-account-panel .room-hero,
.free-room-page.pk-account-panel .room-stats-board,
.free-room-page.pk-account-panel .content-section {
  width: calc(100% - 24px) !important;
  max-width: 1540px !important;
}

.free-room-page.pk-account-panel .room-hero {
  min-height: 318px !important;
  grid-template-columns: 204px minmax(0, 1fr) 250px !important;
  border-color: rgba(255, 132, 31, 0.38) !important;
  box-shadow:
    0 28px 90px rgba(0, 0, 0, 0.38),
    inset 0 1px 0 rgba(255, 224, 170, 0.08) !important;
}

.free-room-page.pk-account-panel .room-avatar img {
  width: 164px !important;
  height: 164px !important;
  box-shadow:
    0 0 48px rgba(255, 138, 0, 0.26),
    0 22px 38px rgba(0, 0, 0, 0.32) !important;
}

.free-room-page.pk-account-panel .room-stats-board {
  gap: 16px !important;
}

.free-room-page.pk-account-panel .content-section {
  padding: 24px !important;
  border-color: rgba(111, 121, 151, 0.22) !important;
}

.free-room-page.pk-account-panel .prize-grid,
.free-room-page.pk-account-panel .winner-grid {
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr)) !important;
  gap: 14px !important;
}

.free-room-page.pk-account-panel .prize-card,
.free-room-page.pk-account-panel .winner-card,
.free-room-page.pk-account-panel .player-card {
  border-color: rgba(111, 121, 151, 0.2) !important;
}

.free-room-page.pk-account-panel .prize-card {
  min-height: 260px !important;
}

.free-room-page.pk-account-panel .prize-card img {
  max-width: 178px !important;
  max-height: 124px !important;
}

@media screen and (max-width: 980px) {
  .free-room-page.pk-account-panel {
    padding: 18px 12px 58px !important;
  }

  .free-room-page.pk-account-panel .room-hero,
  .free-room-page.pk-account-panel .room-stats-board,
  .free-room-page.pk-account-panel .content-section {
    width: 100% !important;
  }

  .free-room-page.pk-account-panel .room-hero {
    grid-template-columns: 1fr !important;
  }
}
</style>
